'use client';

const SLEEKPLAN_URL = 'https://statusly.sleekplan.app';

export function openHelpWidget() {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.$sleek) {
    window.$sleek.open();
    return;
  }

  window.location.href = SLEEKPLAN_URL;
}
